export const fontFamily = {
    header: "CormorantLight",
    content: "NeutrafaceTextLight",
    accent: "ProximaNovaRegular"
}
